import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  divider: {
    width: 2,
    backgroundColor: '#250074',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  progressArea: {
    flex: 1,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    justifyItems: 'center',
    flexDirection: 'row'
  },
  dividerArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  commentPaperArea: {
    height: 100,
    padding: 10,
    backgroundColor: '#eceef7',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  dividerCircle: {
    height: 18,
    width: 18,
    border: '2px solid',
    borderRadius: 9,
    borderColor: '#250074',
    backgroundColor: 'white',

    position: 'absolute'
  },

  commentDateArea: {
    borderRight: '2px solid #C2CAD3'
  },
  commentDay: {
    fontSize: 30,
    color: '#250074',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  commentHour: {
    fontSize: 18,
    color: '#250074',
    textAlign: 'center'
  },
  commentTextArea: {
    fontSize: 20,
    color: '#606060',
    marginLeft: 20,

    display: 'flex',
    justifyContent: 'space-between'
  },
  buttonArea: {
    fontSize: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row'
  },
  modalTableRoot: {
    width: '100%'
  },
  modalTableContainer: {
    maxHeight: 440
  },
  commentsModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  commentsPaper: {
    position: 'absolute',
    width: 1000,
    maxHeight: 800,
    backgroundColor: 'white',
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  },

  publishIcon: {
    color: 'black',
    fontSize: 25
  },
  trashIcon: {
    color: 'red',
    fontSize: 25
  }
}))

export default useStyles
